<template>
  <div>
    <header class="main_header">
      <div class="left_div">
        <div class="logo logo_heading">
          <a href="/"><img src="https://www.sitepal.com/api/examples/images/logo.png" alt="SitePal"></a>
        </div>
      </div>
    </header>

    <table id="tblContainer" cellspacing="0" align="center" border="0" width="50%" style="min-height: 73vh;">
      <tbody>
        <tr>
          <td id="tdContent">
            <p class="feature_entire_heading text-center f-bold h2" align="center"><b>SitePal Conversation Example in
                Vue JS</b></p>
            <p class="feature_entire_heading text-center" align="center">Two characters have a conversation</p>
            <table width="90%" align="center">
              <TR>
                <TD align="center">
                  <SitePal spn="abc"
                    embed='3432155,300,400,"",1,1, 2695938, 0,1,1,"83e9cf749c828c00f267098eefd1eca5",0' />
                </TD>
                <TD align="center">
                  <SitePal spn="xyz"
                    embed='3432155,300,400,"",1,1, 2695693, 0,1,1,"85c776a6ec18b1e8cafedc94fdd0f31b",0' />
                </TD>
              </TR>
              <TR>
                <TD align="center" colspan="2">

                  <form action="#" name="messageForm">
                    <textarea cols=70 rows=10 name="message" READONLY class="feature_entire_heading"></textarea>
                  </form>
                </TD>
              </TR>
              <TR>
                <TD align="middle" colspan="2">
                  <SPAN CLASS="content"><a style="cursor: pointer;" class="selected_support" @click="start"><b>Start the
                        Conversation</b></a></SPAN>

                </td>
              </tr>
              <TR width="60%">
                <td align="left" class="feature_entire_heading" colspan="2">
                  The value returned by the 'AC_VHost_Embed' function is the Scene reference.
                  The male character on the left has its Scene reference assigned to variable 'a'.
                  The female character on the right has its Scene reference assigned to variable 'b'.
                  The variables 'a' or 'b' are passed to the 'selectPortal' function.

                </TD>
              </tr>
              <tr width="60%">
                <td align="left" class="feature_entire_heading" colspan="2">
                  The 'selectPortal' call determines which Scene is the active target of subsequent API calls.

                </TD>
              </TR>
              <tr width="60%">
                <td align="center" class="feature_entire_heading">


                </td>
              </tr>
            </TABLE>
          </td>

        </tr>
      </tbody>
    </table>

    <footer>
      <div class="footer-menu oddcast text-center">
        <ul class="w-50 m-auto ">
          <li class="w-100 f-bold ">Please feel free to use the source code of this page as an example.</li>
          <li>To view the source code of this page, <a href="/api/examples/vue-conversation/Sitepal-vue.zip"
              download="">download</a>
            souce code</li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
window.vh_audioProgress = function (percentPlayed) {
  document.forms[0].message.value += "Received 'vh_audioProgress' at " + percentPlayed + "% \n";
}

window.vh_sceneLoaded = function () {
  window.setStatus(1, 0, 0, 1);
  document.forms[0].message.value += "Received 'vh_sceneLoaded' event \n   calling: 'setStatus(1, 0, 0, 1)' \n";
}

window.vh_audioStarted = function () {
  document.forms[0].message.value += "Received 'vh_audioStarted' event \n";
}

window.vh_audioEnded = function () {
  document.forms[0].message.value += "Received 'vh_audioEnded' event \n";
  window.vh_talkEnded_Sitepal();
}

import SitePal from 'sitepal-vue'

export default {
  name: 'ThreeDCharacter',
  components: {
    SitePal
  },
  mounted() {
    // Make vh_talkEnded accessible globally
    window.vh_talkEnded_Sitepal = this.vh_talkEnded;
  },
  methods: {
    sayText: function (txt, voice, lang, engine) {
      window.sayText(txt, voice, lang, engine);
    },
    sayAudio: function (audioName) {
      window.sayAudio(audioName);
    },
    start: function () {
      document.messageForm.message.value += "start event received.\n";
      window.initialClick = true;
      //transform the array into object form 
      window.portalArrayObjects = window.portalArray.reduce((acc, item) => {
        const key = Object.keys(item)[0];
        acc[key] = item[key];
        return acc;
      }, {});


      window.currentStep = 1;
      this.conversation();
      setTimeout(() => {
        window.initialClick = false;
      }, 2000);
    },

    vh_talkEnded: function () {
      if (window.initialClick) {
        window.initialClick = false;
        return;
      }
      document.messageForm.message.value += "Received vh_talkEnded(); \n";
      setTimeout(() => {
        window.currentStep += 1;
        this.conversation();
      }, 50);
    },

    conversation: function () {

      var currentStep = window.currentStep;
      var a = window.portalArrayObjects['abc'];
      var b = window.portalArrayObjects['xyz'];

      document.messageForm.message.value += "conversation(); currentStep "+currentStep+ " \n";
      switch (currentStep) {
        case 1:
          window.selectPortal(b);
          window.setGaze(270, 5, 100);
          window.selectPortal(a);
          window.sayText('Welcome to the SitePal conversation example page', 2, 1, 3);
          break
        case 2:
          window.selectPortal(a);
          window.setGaze(90, 5, 100);
          window.selectPortal(b);
          window.sayText('When multiple Scenes are embedded on the same page, only one of them accepts API calls at any given time.', 1, 1, 3);
          break
        case 3:
          window.selectPortal(b);
          window.setGaze(270, 5, 100);
          window.selectPortal(a);
          window.sayText('The "Select Portal" call can be used to select the Scene that accepts API calls.', 2, 1, 3);
          break
        case 4:
          window.selectPortal(a);
          window.setGaze(90, 5, 100);
          window.selectPortal(b);
          window.sayText('To use this call, you must collect the Scene reference when the embedded Scene is loaded – by assigning the values returned by the “Embed” function', 1, 1, 3);
          break
      }
    }
  },
};
</script>

<style scoped>
@import 'https://sitepal.com/api/examples/css/apiExample.css';

header {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding: .5rem 1rem;

  p {
    margin-left: 1rem;
  }
}

nav {
  margin-left: auto;

  ul {
    list-style: none;
  }

  ul li {
    display: inline-flex;
    margin-left: 1rem;
  }
}
</style>